// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import {
  init,
  replayIntegration,
  captureRouterTransitionStart,
} from '@sentry/nextjs';

init({
  dsn: 'https://70a9c5743e5dbd6d8b8e8cac72699c0b@o4509088428523520.ingest.us.sentry.io/4509088643940352',

  // Add optional integrations for additional features
  integrations: [replayIntegration()],

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 0.5,

  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,

  // 忽略特定类型的错误
  ignoreErrors: [/^AbortError/, /^Hydration/, /^Non-Error/],

  initialScope: {
    tags: {
      env: process.env.NEXT_PUBLIC_ENV || 'development',
    },
  },
});

// 导出必需的路由转换hook以支持导航监控
export const onRouterTransitionStart = captureRouterTransitionStart;
